// components/Waitlist.js
import React, { useState } from 'react';
import './Waitlist.css';

function Waitlist() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus('invalid');
      setIsSubmitting(false);
      return;
    }

    try {
      if (process.env.NODE_ENV === 'development') {
        await new Promise(resolve => setTimeout(resolve, 1000));
        setStatus('success');
        setEmail('');
      } else {
        const response = await fetch('/api/waitlist', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ email }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Failed to submit email');
        }

        if (data.status === 'duplicate') {
          setStatus('duplicate');
        } else {
          setStatus('success');
          setEmail('');
        }
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStatusMessage = () => {
    switch (status) {
      case 'success':
        return process.env.NODE_ENV === 'development'
          ? "Thanks for joining! (Demo mode)"
          : "Thanks for joining! We'll be in touch soon.";
      case 'invalid':
        return 'Please enter a valid email address.';
      case 'duplicate':
        return 'This email is already on our waitlist!';
      case 'error':
        return 'Sorry, there was an error. Please try again later.';
      default:
        return '';
    }
  };

  return (
    <section id="waitlist-section" className="waitlist">
      <div className="waitlist__glow" />
      <div className="waitlist-container">
        <p className="section-eyebrow">Early Access</p>
        <h2>Get Started with Bottomless Postgres</h2>
        <p className="waitlist-description">
          Be among the first to run AI workloads on bottomless Postgres. We're in private alpha — spots are limited.
        </p>

        {process.env.NODE_ENV === 'development' && (
          <p className="waitlist-dev-notice">
            🚧 Dev Mode — emails logged to console only
          </p>
        )}

        <form className="waitlist-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setStatus('');
              }}
              placeholder="you@company.com"
              required
              disabled={isSubmitting}
              className={`email-input ${status === 'invalid' ? 'error' : ''}`}
            />
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Join Waitlist'}
            </button>
          </div>
          {status && (
            <p className={`status-message ${status}`}>
              {getStatusMessage()}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

export default Waitlist;